//React & libs
import { memo, useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import { SimpleText, SimpleButton, ImageSelectList } from "../../components";
import { useNavigate, useLocation } from "react-router-dom";

//Assets
import disabilityImage from "../../assets/images/png/disabilityImage.png";
import disabilityCotranst from "../../assets/images/png/disabilityCotranst.png";
import BackIcon from "../../assets/images/svg/BackIcon";
import i18n from "../../localization/i18n";

import contrast from "../../assets/images/png/contrast.png";
import dyslexia from "../../assets/images/png/dyslexia.png";
import dioptria from "../../assets/images/png/dioptria.png";
import mainLogo from "../../assets/images/png/mainLogo.png";
import mainLogoContrast from "../../assets/images/png/mainLogoContrast.png";
import mupHnkLogo from "../../assets/images/svg/mupHnkLogo.svg";

import { useTranslation } from "react-i18next";
import { IS_MUP_HNK } from "../../util/organization";

//Redux
import { changeDisabilityFunc } from "../../redux/features/settings/settingsSlice";
import { AppDispatch } from "../../redux/store.ts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store.ts";

//Components
import CheckStatusDialog from "../home/components/CheckStatusDialog.tsx";

const items = [
  { value: "bh", tooltip: "Bosnian" },
  { value: "hr", tooltip: "Croatian" },
  { value: "sr", tooltip: "Serbian" },
  { value: "en", tooltip: "English" },
];

const disabilitys = [
  {
    value: "dislexia",
    img: dyslexia,
    tooltip: "Dyslexia",
  },
  {
    value: "diopteres",
    img: dioptria,
    tooltip: "Diopter",
  },
  {
    value: "contrast",
    img: contrast,
    tooltip: "Contrast",
  },
];

const Header = () => {
  const { contrast } = useSelector(
    (state: RootState) => state?.settings?.data?.disability,
  );
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const location = useLocation();

  const [lang, setLang] = useState<string>("bh");
  const [selectedDisabilitys, setSelectedDisabilitys] = useState<string[]>([]);
  const [checkStatus, setCheckStatus] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleCheckStatus = () => {
    setCheckStatus((pre) => !pre);
  };

  const handleBack = () => {
    navigate(-1);
  };
  const changeLanguage = (language: string) => {
    setLang(language);
    i18n.changeLanguage(language);
    localStorage.setItem("lang", JSON.stringify(language));
  };

  const changeDisabilitys = (
    disabilitys: string[] | ((prev: string[]) => string[]),
  ) => {
    if (typeof disabilitys === "function") {
      setSelectedDisabilitys(disabilitys(selectedDisabilitys));
      localStorage.setItem(
        "disabilities",
        JSON.stringify(disabilitys(selectedDisabilitys)),
      );
    }
  };
  const handleChangeDisability = (e: string) => {
    if (e == "dislexia" || e == "diopteres" || e == "contrast")
      dispatch(changeDisabilityFunc({ disability: e }));
  };

  useEffect(() => {
    const storedLang = localStorage.getItem("lang");
    let storedDisabilities: string[] = [];
    try {
      storedDisabilities = JSON.parse(
        localStorage.getItem("disabilities") || "[]",
      );
    } catch {
      localStorage.removeItem("disabilities");
    }

    if (storedLang) {
      let lang;
      try {
        // Try to parse as JSON first
        lang = JSON.parse(storedLang);
      } catch {
        // If it fails, use the string value directly
        lang = storedLang;
      }
      setLang(lang);
      i18n.changeLanguage(lang);
    }

    if (storedDisabilities.length > 0) {
      setSelectedDisabilitys(storedDisabilities);
      storedDisabilities.forEach((disability: string) =>
        handleChangeDisability(disability),
      );
    }
  }, []);

  return (
    <Grid
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100vw",
        alignItems: "center",
        position: "sticky",
        top: "0px",
        background: "#fff",
        zIndex: 999,
        paddingBottom: "5px",
      }}
      sx={{
        marginTop: {
          md: "30px",
          lg: "50px",
          xs: "15px",
        },
      }}
    >
      {location.pathname != "/" && (
        <Box
          sx={{
            display: {
              md: "none",
              lg: "none",
              xs: "flex",
            },
          }}
        >
          <button
            onClick={handleBack}
            style={{
              border: "none",
              outline: "none",
              background: "transparent",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <BackIcon />
            <SimpleText
              value="Back"
              type="subText"
              sx={{
                marginLeft: "5px",
              }}
            />
          </button>
        </Box>
      )}
      <Box
        component="img"
        src={
          IS_MUP_HNK ? mupHnkLogo : contrast ? mainLogoContrast : mainLogo
        }
        alt="lang"
        sx={{
          objectFit: IS_MUP_HNK ? "contain" : "cover",
          borderRadius: IS_MUP_HNK ? 0 : "4px",
          marginLeft: {
            md: "50px",
            lg: "100px",
            xs: "20px",
          },
          height: IS_MUP_HNK
            ? {
                md: "90px",
                lg: "110px",
                xs: "50px",
              }
            : {
                md: "128px",
                lg: "160px",
                xs: "64px",
              },
          width: IS_MUP_HNK
            ? {
                md: "75px",
                lg: "92px",
                xs: "42px",
              }
            : {
                md: "183px",
                lg: "228px",
                xs: "92px",
              },
          marginRight: "45px",
        }}
      />
      {/*    <SimpleText
        value="eAppointment.ba"
        type="title"
        sx={{
          marginLeft: {
            md: "50px",
            lg: "100px",
            xs: "20px",
          },
          marginRight: "40px",
        }}
      />*/}
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        sx={{
          marginRight: {
            md: "50px",
            lg: "100px",
            xs: "20px",
          },
          display: {
            md: "flex",
            lg: "flex",
            xs: "none",
          },
        }}
      >
        <SimpleButton
          buttonLabel="Checking reservation status"
          onClick={handleCheckStatus}
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xs: "none",
            },
            marginRight: "30px",
          }}
          type="mainButton"
        />
        <Box
          sx={{
            marginRight: "20px",
            display: {
              md: "flex",
              lg: "flex",
              xs: "none",
            },
          }}
        >
          <ImageSelectList
            items={disabilitys}
            toolTip={t("Accessibilities")}
            selectedImages={contrast ? disabilityCotranst : disabilityImage}
            multiple={true}
            selectedItems={selectedDisabilitys}
            setSelectedItems={changeDisabilitys}
            setSelectedValue={handleChangeDisability}
          />
        </Box>

        <ImageSelectList
          items={items}
          selectedValue={lang}
          setSelectedValue={changeLanguage}
          toolTip={t("Language")}
        />
      </Box>
      <CheckStatusDialog open={checkStatus} setOpen={setCheckStatus} />
    </Grid>
  );
};

export default memo(Header);
